<template>
  <div class="cart-item">
    <div class="p-2 flex flex-col justify-center items-center gap-2">
      <div class="grid grid-cols-6 justify-around gap-1">
        <Ball
          v-for="ball in balls"
          class="justify-self-center"
          :number="ball.ball"
          size="30px"
          @click="cartStore.selectDuotoneBallItem(ball)"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { useCartStore } from '@/stores/cart.js'
import Ball from '@/components/Ball.vue'
import {computed} from "vue"
import { filter } from 'lodash-es'

const props = defineProps({
  data: {
    type: Object,
    default: () => ({})
  }
})

const cartStore = useCartStore()

const balls = computed(() => filter(props.data, (item, index) => index < 6))

</script>
